import { Module } from "vuex-smart-module"

import AuthState from "./state"
import AuthMutations from "./mutations";
import AuthGetters from "./getters";
import AuthActions from "./actions"

export const authModule = new Module({
    state: AuthState,
    getters: AuthGetters,
    mutations: AuthMutations,
    actions: AuthActions
})


